<template>
  <IconListItem
    icon="serial-number"
    :label="label ?? $t('myorders.listitem.games.label', totalDraws)"
  >
    {{ totalDraws }}
  </IconListItem>
</template>

<script lang="ts" setup>
type MyOrdersListItemGamesTotalProps = {
  label?: string
  totalDraws: number
}

defineProps<MyOrdersListItemGamesTotalProps>()
</script>
